import styled from 'styled-components';
import Parent from '../Base/style';

const Wrapper = styled(Parent.Wrapper)``;
const UploadWrapper = styled(Parent.UploadWrapper)``;
const PopupUpload = styled(Parent.PopupUpload)``;
const Styled = { Wrapper, UploadWrapper, PopupUpload };
export default Styled;
